export enum MaritalStatus {    
    Single = 1,
    Married = 2,
    Divorced = 3,
    Widowed = 4
}